import React from 'react'
import '../../App.css'

export default function MailingList() {
  return <h1 className="mailing-list">MAILING LIST</h1>
}